<template>
  <div class="create" @keyup.13="submit">
    <mu-dialog title="新增菜单" width="500" :open="open" @close="close">
      <mu-form :model="form" label-position="left" label-width="100" ref="form">
        <mu-form-item prop="name" label="名称">
          <mu-text-field v-model="form.name"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="description" label="描述">
          <mu-text-field v-model="form.description"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="url" label="页面url">
          <mu-text-field v-model="form.url"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="apiUrl" label="apiUrl">
          <mu-text-field v-model="form.apiUrl"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="icon" label="icon">
          <mu-text-field v-model="form.icon"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="menuLevel" label="菜单等级">
          <mu-radio
            value="一级"
            v-model="form.menuLevel"
            label="一级"
          ></mu-radio>
          <mu-radio
            value="二级"
            v-model="form.menuLevel"
            label="二级"
          ></mu-radio>
          <mu-radio
            value="三级"
            v-model="form.menuLevel"
            label="三级"
          ></mu-radio>
        </mu-form-item>

        <mu-form-item prop="parent" label="父菜单" v-if="form.menuLevel">
          <mu-select v-model="form.parent.id">
            <mu-option
              v-for="(item, index) in parentMenuList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></mu-option>
          </mu-select>
        </mu-form-item>

        <mu-form-item prop="isMenu" label="是否为菜单">
          <mu-radio :value="true" v-model="form.isMenu" label="是"></mu-radio>
          <mu-radio :value="false" v-model="form.isMenu" label="否"></mu-radio>
        </mu-form-item>

        <mu-form-item prop="auto" label="添加增删改">
          <mu-radio :value="true" v-model="form.auto" label="是"></mu-radio>
          <mu-radio :value="false" v-model="form.auto" label="否"></mu-radio>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
      <mu-button slot="actions" color="primary" @click="submit">提交</mu-button>
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        name: '',
        description: '',
        url: '',
        apiUrl: '',
        menuLevel: '',
        isMenu: false,
        icon: '',
        auto: false,
        parent: {
          id: 1
        }
      },
      allMenuList: [],
      parentMenuList: []
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate().then((flag) => {
        if (flag) {
          backend(api.menu.create, this.form).then((result) => {
            if (result.statusCode === 200) {
              this.close()
              this.$emit('finish')
              this.form = {
                name: '',
                description: '',
                url: '',
                apiUrl: '',
                menuLevel: '',
                isMenu: false,
                icon: '',
                auto: false,
                parent: {
                  id: 1
                }
              }
            }
          })
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    },
    getAllMenus() {
      backend(api.menu.getAll, { getAll: true }).then((result) => {
        if (result.statusCode === 200) {
          this.allMenuList = result.data.rows
        }
      })
    }
  },
  mounted() {
    this.getAllMenus()
  },
  watch: {
    'form.menuLevel': {
      handler(val) {
        if (val === '一级') {
          this.parentMenuList = this.allMenuList.filter(
            (x) => x.menuLevel === '根菜单'
          )
        } else if (val === '二级') {
          this.parentMenuList = this.allMenuList.filter(
            (x) => x.menuLevel === '一级'
          )
        } else if (val === '三级') {
          this.parentMenuList = this.allMenuList.filter(
            (x) => x.menuLevel === '二级'
          )
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.create {
}
</style>



// WEBPACK FOOTER //
// src/views/menu/create.vue